module.exports = __webpack_public_path__ + "static/img/part3.d30a466.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/UnderdogDetective/bottom/part3/part3.jpg
// module id = 88yy
// module chunks = 0